import firebase from '../firebase'
import { observable } from 'mobx'
import Logger from '../stores/Logger'

class AuthStore {
    constructor() {
        this.auth = observable({
            authUser: null,
            authError: null,
            userProfile: null,
            onFreePlan: true,
            loginCount: 0,
            refreshIntervalTimer: null,
            primaryTeam: {},
            teamPhoto: '/Logo.png',
            isTeamAdmin: false,
            assignedTeams: [],
            teamList: [],
            manuallyChangedTeams: false,
        })
        firebase.auth().onIdTokenChanged(user => {
            this.auth.authUser = user
            if(!user){
                Logger.userLoggedOut() //logged out
            }            
        })
        this.unwatchAuth = firebase.auth().onAuthStateChanged(user => {
            // console.log('==>unwatchAuth')
            // console.log(user)
            this.auth.authUser = user

            if(user){
                //now the displayName is ready, lets set it in DB, and use email if not available
                var dispName = user.displayName ? user.displayName : user.email.split('@')[0]
                var photoURL = user.photoURL ? user.photoURL : `https://ui-avatars.com/api/?name=${user.displayName}&color=707070&background=cccccc&size=60`

                user.updateProfile({
                  displayName: dispName,
                  photoURL: photoURL,
                }).then(function () {
                  // Update successful.
                }, function (error) {
                    console.error(error)
                  // An error happened.
                })

                const userRef = firebase.database().ref().child('users/'+user.uid)
                userRef.on('value', snap => {
                    // console.log(snap.val())
                    if (snap.val()){
                        this.auth.userProfile = snap.val()
                        this.auth.onFreePlan = (snap.val().plan !== 'single_user_paid_private') ? true : false

                        //Load teams
                        this.loadTeam()
                    }
                }, null, this)

                firebase.database().ref('users/'+user.uid+'/displayName').set(dispName)

                var refreshTokenRef = firebase.database().ref('users/'+user.uid+'/refreshToken')
                refreshTokenRef.set(user.refreshToken)
                // console.log('user.refreshToken:',user.refreshToken)
                
                //periodically refresh the JWT Id Token to stay authenticated
                this.refreshIntervalTimer = setInterval(() => {
                    user.getIdToken().then(jwtToken => {
                        // console.log('got refreshed token:',jwtToken)
                        refreshTokenRef.set(jwtToken)
                    })
                }, 5*60*1000) //find the longes possible time, that still works. Linda Lawton on the case

                //count number of user logins
                firebase.database().ref('users/'+user.uid+'/login_count').once('value').then(snap => {
                    let count = 0
                    if(snap.exists()){
                        count = snap.val()
                    }else{
                        Logger.userSignedUp(user)
                        this.sendVerificationEmail(user)                        
                    }
                    count += 1
                    firebase.database().ref('users/'+user.uid+'/login_count').set(count)
                    this.auth.loginCount = count
                }, null, this)

                //from: https://firebase.google.com/docs/database/web/offline-capabilities

                // since I can connect from multiple devices or browser tabs, we store each connection instance separately
                // any time that connectionsRef's value is null (i.e. has no children) I am offline
                var myConnectionsRef = firebase.database().ref('users/'+user.uid+'/connections')

                // stores the timestamp of my last disconnect (the last time I was seen online)
                var lastOnlineRef = firebase.database().ref('users/'+user.uid+'/lastOnline')

                var connectedRef = firebase.database().ref('.info/connected')
                connectedRef.on('value', function (snap) {
                  if (snap.val() === true) {
                    // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)

                    // add this device to my connections list
                    // this value could contain info about the device or a timestamp too
                    var con = myConnectionsRef.push(true)

                    // when I disconnect, remove this device
                    con.onDisconnect().remove()

                    // when I disconnect, update the last time I was seen online
                    lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP)
                  }
                })

                Logger.userSignedIn(user) //logged in
            }else{
                if(this.refreshIntervalTimer)
                    clearInterval(this.refreshIntervalTimer)

                this.auth.primaryTeam = {}
                this.auth.userProfile = {}
                this.auth.onFreePlan = true
                this.auth.loginCount = 0

                //TODO: need to .off() but uid not available: firebase.database().ref().child('users/'+user.uid).off()
                Logger.userLoggedOut() //logged out
                console.log('User was logged out')
            }
        })
    }
    loadTeam() {
        let thing = this
        if (this.auth.userProfile.hasOwnProperty('primaryTeam')) {
            let teamKey = this.auth.userProfile.primaryTeam
            firebase.database().ref().child('teams/' + teamKey).on('value', aTeam => {
                if(aTeam.exists()){ 
                    let ptm = aTeam.val()
                    let userID = this.auth.authUser.uid
                    ptm['key'] = aTeam.key
                    let users = {}
                    // console.log('My primary team:',this.auth.primaryTeam)
                    let members = {}
                    if(ptm.hasOwnProperty('members')){
                        members = ptm.members
                    }
                    if(ptm.hasOwnProperty('enableDashboard') === false || (ptm.hasOwnProperty('enableDashboard') && ptm.enableDashboard === false)){
                        firebase.database().ref('users/'+userID+'/prefs/majorMode').set(1)    
                    }
                    let requests = Object.keys(members).map((uid) => {
                        return firebase.database().ref().child('users/' + uid).once('value').then(aUser => {
                            // console.log('got user',aUser.val().displayName)
                            users[uid] = aUser.val()
                        })
                    })
                    Promise.all(requests).then(() => {
                        ptm['users'] = users
                        thing.auth.primaryTeam = ptm
                    })
                }
            })
        }
        if (this.auth.authUser){
            if (typeof this.auth.authUser !== 'undefined' && this.auth.authUser.uid !== undefined){
                // console.log('logged in!')
                let userID = this.auth.authUser.uid
                let teams = []
                let anotherThing = this
                let index = 0
                let ideaTeams = []
                firebase.database().ref().child('teams').once('value').then(teams_snap => {
                    if(teams_snap.exists()){ 
                        teams_snap.forEach(function (theTeam) {
                            var teamObject = theTeam.val()
                            Object.keys(teamObject.members).forEach((member) => {         
                                if (member === userID){
                                    let teamKey = Object.keys(teams_snap.val())[index]
                                    let teamName = teamObject.name
                                    teams.push({teamKey: teamKey, teamName: teamName})
                                    ideaTeams.push({teamKey: teamKey, teamName: teamObject.name, teamPhoto: teamObject.photoURL})
                                }
                            })
                            index++
                        })
                        return teams
                    }
                }).then(function (teams) {
                    anotherThing.auth.assignedTeams = teams
                    anotherThing.auth.teamList = ideaTeams
                    firebase.database().ref('users/'+userID+'/assignedTeams').set(teams)
                }).then(function (teams) {
                    if (anotherThing.auth.userProfile.primaryTeam === undefined || anotherThing.auth.userProfile.primaryTeam === ''){
                        if (anotherThing.auth.assignedTeams.length < 0){
                            firebase.database().ref('users/'+userID+'/primaryTeam').set(anotherThing.auth.assignedTeams[0].teamKey)    
                        }
                    }
                })
            }
        }
    }
    findTeam(teamKey, userID){
        return firebase.database().ref().child('teams/'+teamKey).once('value', function (teamSnap) {
            if (teamSnap.exists()) {
                let team = teamSnap.val()
                return team
            }
            else return null
        })
    }
    fetchTeamsLogo(teamKey){
        console.log('teamKey', teamKey)
        return firebase.database().ref().child('teams/'+teamKey).once('value', function (teamSnap) {
            if (teamSnap.exists()) {
                let team = teamSnap.val()
                console.log('team photo is here', team.photoURL)
                return team
            }
            else return '/Logo.png'
        })
    }
    updateSettings(whichTeamPref, teamPrefValue, teamKey){
        firebase.database().ref().child('teams/' + teamKey + '/' + whichTeamPref).set(teamPrefValue)
    }
    findTeamAdmins(teamKey, userId){
        let adminFound = false
        return firebase.database().ref('teams/' + teamKey + '/admin').once('value').then(adminSnap => {
            if (adminSnap.exists()) {
                let teamAdmins = adminSnap.val()
                Object.keys(teamAdmins).forEach((adminId, newIndex) => {
                    if(adminId === userId){
                        return adminFound = true
                    }
                })
            }
        }).then(() => {
            this.auth.isTeamAdmin = adminFound
            return adminFound
        })
    }
    watchAuth(onUser, onError) {
        return firebase.auth().onIdTokenChanged(onUser, onError)
    }
    changeTeam(team, inIdeaPage){
        if (inIdeaPage === false){
            this.auth.manuallyChangedTeams = true
        }
        return firebase.database().ref('users/'+this.auth.authUser.uid+'/primaryTeam').set(team)
    }
    updateDisplayName(value) {
        this.auth.authUser.updateProfile({displayName: value})
        firebase.database().ref('users/'+this.auth.authUser.uid+'/displayName').set(value)
    }
    updateProfileImage(value){
        this.auth.authUser.updateProfile({photoURL: value})
        firebase.database().ref('users/'+this.auth.authUser.uid+'/photoURL').set(value)
    }
    updateTeamName(value) {
        if (value !== ''){
            firebase.database().ref('teams/'+this.auth.primaryTeam.key+'/name').set(value)
            this.loadTeam()
        }
    }
    updateTeamProfileImage(value){
        firebase.database().ref('teams/'+this.auth.primaryTeam.key+'/photoURL').set(value)
    }
    authUser() {
        return this.auth.authUser
    }
    authError() {
        return this.auth.authError
    }
    userProfile() {
        return this.auth.userProfile
    }
    primaryTeam() {
        return this.auth.primaryTeam
    }
    onFreePlan() {
        return this.auth.onFreePlan
    }
    signIn({email, password}) {
        if (this.auth.authUser) {
            return Promise.resolve(this.auth.authUser)
        }
        return firebase.auth().signInWithEmailAndPassword(email, password)
            .then(user => {
                this.auth.authError = null
                return user
            })
            .catch(error => {
                this.auth.authError = error
                throw error
            })
    }
    createUser({email, password}) {
        return firebase.auth().createUserWithEmailAndPassword(email, password)
            .then(ret => {
                this.auth.authError = null
                return true
            })
            .catch(error => {
                this.auth.authError = error
                Logger.trackEvent('signUpError', 'error', error.toString())
                throw error
            })
    }
    sendPasswordResetEmail(user){
        return firebase.auth().sendPasswordResetEmail(user.email).then(function () {
            return alert('password reset email sent to '+user.email)
        }).catch(function (error) {
            return alert('error:'+error)
        })
    }
    sendVerificationEmail(user){
        if(!user.emailVerified){
            user.sendEmailVerification().then(res => {
                console.log('Email-address verification mail sent')
                Logger.trackEvent('emailVerificationSent')
            }).catch(err => {
                console.error('Failed sending email verification mail sent to:', user.uid, user.email)
            })
        }
    }
    storeStripeToken(token){
        if(token){ 
            firebase.database().ref().child('stripe_customers/'+this.auth.authUser.uid+'/sources').push({'token': token.id})
        }
    }
    downgradeToLowerPlan(newPlan){
        //Downgrading
        if(newPlan === 'single_user_free'){
            firebase.database().ref().child('stripe_customers/'+this.auth.authUser.uid+'/move_to_new_plan').set(newPlan)
        }
    }
    //This should be called if we have multiple instances of AuthStore.
    // For example, if AuthStore lives inside an App component, call cleanup() in App's componentWillUnmount.
    //If there's only a singleton AuthStore, then it's ok to never call this.
    cleanup() {
        if (this.unwatchAuth) {
            this.unwatchAuth()
        }
    }
    signOut() {
        Logger.userLoggedOut()
        firebase.database().ref('users/'+this.authUser.uid).off()
        return firebase.auth().signOut()
            .then(() => {
                this.auth.authError = null
                this.auth.primaryTeam.key = null
            })
            .catch(error => {
                this.auth.authError = error
                throw error
            })
    }
}

export default AuthStore



// WEBPACK FOOTER //
// ./src/stores/AuthStore.js